// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.snackbar__container {
  position: fixed;
  top: 2rem;
  left: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  z-index: 9999999;
  border-radius: 4px;
  width: 90%;
  max-width: fit-content;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
  padding: 0;
  animation: 300ms ease-out forwards slide-up;
  overflow: hidden;
}

.snackbar__container__error {
  background: #e32222;
}

.snackbar__container__success {
  background: #17A300;
}

.snackbar__label {
  line-height: 1rem;
  padding-left: 16px;
  padding-right: 8px;
  width: 100%;
  margin: 0;
  padding-top: 14px;
  padding-bottom: 14px;
}

.snackbar__dismiss {
  color: #fff;
  font-size: 150%;
  font-weight: bold;
  margin-left: 8px;
  margin-right: 8px;
  cursor: pointer;
  padding: 8px;
}

@keyframes slide-up {
  from {
    opacity: 0;
    transform: translate(-50%, 0);
  }
  to {
    opacity: 1;
    transform: translate(-50%, 3rem);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Snackbar/snackbar.scss"],"names":[],"mappings":"AACA;EACE,eAAA;EACA,SAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,sBAAA;EACA,yHAAA;EAEA,UAAA;EACA,2CAAA;EACA,gBAAA;AADF;;AAIA;EACE,mBAAA;AADF;;AAIA;EACE,mBAAA;AADF;;AAIA;EACE,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,iBAAA;EACA,oBAAA;AADF;;AAIA;EACE,WAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;AADF;;AAIA;EACE;IACE,UAAA;IACA,6BAAA;EADF;EAGA;IACE,UAAA;IACA,gCAAA;EADF;AACF","sourcesContent":["\n.snackbar__container {\n  position: fixed;\n  top: 2rem;\n  left: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  z-index: 9999999;\n  border-radius: 4px;\n  width: 90%;\n  max-width: fit-content;\n  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2),\n    0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);\n  padding: 0;\n  animation: 300ms ease-out forwards slide-up;\n  overflow: hidden;\n}\n\n.snackbar__container__error {\n  background: #e32222;\n}\n\n.snackbar__container__success {\n  background: #17A300;\n}\n\n.snackbar__label {\n  line-height: 1rem;\n  padding-left: 16px;\n  padding-right: 8px;\n  width: 100%;\n  margin: 0;\n  padding-top: 14px;\n  padding-bottom: 14px;\n}\n\n.snackbar__dismiss {\n  color: #fff;\n  font-size: 150%;\n  font-weight: bold;\n  margin-left: 8px;\n  margin-right: 8px;\n  cursor: pointer;\n  padding: 8px;\n}\n\n@keyframes slide-up {\n  from {\n    opacity: 0;\n    transform: translate(-50%,0);\n  }\n  to {\n    opacity: 1;\n    transform: translate(-50%,3rem);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
